import { gql } from 'urql';

const SubmitPayOverTimeManualPayment = gql`
  mutation SubmitPayOverTimeManualPayment(
    $idempotencyId: ID!
    $input: PayOverTimeSubmitManualPaymentInput!
  ) {
    submitPayOverTimeManualPayment(
      idempotencyId: $idempotencyId
      input: $input
    ) {
      __typename
      ... on PayOverTimeSubmitManualPaymentSuccess {
        id
        paymentMessage {
          captionText
          headlineText
          messageText
          noteText
        }
        outstandingBalance {
          amount
          currency
          formatted
          formattedWithPlusPrefix
          formattedWithPlusPrefixOrAbs
        }
      }
      ... on PayOverTimeSubmitManualPaymentError {
        code
        message
        title
      }
    }
  }
`;

export default SubmitPayOverTimeManualPayment;
